























































































































































































































//@ts-nocheck
import { Component, Prop, Vue } from 'vue-property-decorator';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'

@Component({
    data() {
    return {
        show:false
    }},
components: {
  VueGoodTable,
},
mounted(){

    
    console.log('ss-----')
     console.log(this.columns)
    //this.formatrow();
     this.show=true;

},
methods:{
    formatrow(){
let data=[];
let labels=this.$store.state.labels.table;
//console.log(labels);
this.columns.forEach(element => {

   
 data.push( {
      label: labels[element.tag],
       sortable: true,
        type: (element.tag=='id')?'number':'string',
      field: element.data,
       filterOptions: {
  	  enabled: element.active, // enable filter for this column
      placeholder: 'Buscar', // placeholder for filter input
      filterValue: '', // initial populated value for this filter
      //filterDropdownItems: [], // dropdown (with selected values) instead of text input
      //filterFn: this.columnFilterFn, //custom filter function that
      trigger: 'keyup', //only trigger on enter not on keyup 
    }});
   
  
    
    
})
return data;
}
}})
export default class HelloWorld extends Vue {
  @Prop() private rows!: any;
  @Prop() private columns!: any;
   @Prop() private add!: bool;
      @Prop() private search:any =true;
          @Prop() private pagination:any =true;
  @Prop() private nameButton!: any;
    @Prop() private showButton!:any ;
    @Prop() private selid!:any =0;
  
}
